export const IS_SETUP_COMPLETED_KEY = 'is_setup_completed';

/**
 * The claim carrying Clerk's own organization id (`org_2abc…`), resolved via `organizations.clerk_org_id`.
 *
 * The only org claim the client reads. The token may still carry `org_id`, our `organizations.id`
 * uuid copied from Clerk org metadata, but nothing here reads it: that metadata is unset for any org
 * whose signup was interrupted, and the backend resolves the uuid from this claim instead (MDC-4505).
 */
export const CLERK_ORG_ID_CLAIM = 'clerk_org_id';

/**
 * The shape of our Clerk session token, declared once so the per-app `CustomJwtSessionClaims`
 * augmentations cannot drift apart.
 *
 * They already had: the dashboard carried two separate declarations, one of which spelled the setup
 * flag `isSetupCompleted` while every reader in both apps looks up `is_setup_completed`. Because
 * global interface declarations merge rather than conflict, that typed a key nothing ever writes and
 * nothing ever read, in silence.
 *
 * Each app still needs its own one-line `declare global` — a module cannot augment the global scope
 * on another module's behalf — but the members live here.
 *
 * The org claim is optional: it is absent until the `one_hour_token` template is configured to emit
 * it (MDC-4480), and on the session token itself. Code reading it must treat that as the normal case,
 * not an error.
 */
export type AppSessionClaims = {
  metadata: {
    [IS_SETUP_COMPLETED_KEY]?: boolean;
  };
  [CLERK_ORG_ID_CLAIM]?: string;
};
